import { Component, OnInit } from '@angular/core';
import {UtilsModule} from 'src/app/common/utils/utils.module';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { ToastrService } from 'ngx-toastr';
import {AuthloginService} from 'src/app/services/login/authlogin.service';

@Component({
  selector: 'app-shapefileupload',
  templateUrl: './shapefileupload.component.html',
  styleUrls: ['./shapefileupload.component.css']
})
export class ShapefileuploadComponent implements OnInit {
  validation: boolean[] = new Array(5).fill(true);
  // validatefields : object = {aquiferfile : true,notifyareafile : true}
  shapefileupload : object ={assesmentyear:null,state:null,hierarchy:null};
  activespineer : boolean;
  shapefileresponse = {};
  userdetails : any;
  shapefileflag :boolean;
  fieldDropDownList : object = {AssesmentYearList:[],StateList:[],AssesmentHierarchy:[]};
  constructor(private utils : UtilsModule,
    private submitdataService : SubmitdataService,
    private toastr : ToastrService,
    private  authlogin : AuthloginService) { }

  ngOnInit() {
    this.initializeOnStateLoad();
  }
  initializeOnStateLoad(){
    console.log(this.shapefileupload)
    document.getElementById('fileupload')['value'] = null;
    this.userdetails = this.authlogin.checkloginstatus();
    this.shapefileupload['state'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID'];
    this.shapefileupload['unit'] = "";
    this.shapefileupload['aquiferfile'] = null
    this.shapefileupload['hierarchy'] = null
    this.getAssesmentYear();
    this.initparams();
  }
  initparams(){
    this.shapefileupload["assesmentyear"] = ""
  }
  getAssesmentYear(){
    this.fieldDropDownList['AssesmentYearList'] = this.submitdataService.getassesmentYear();
    console.log(this.fieldDropDownList['AssesmentYearList']);
    
  }

  public uploadfile(type){
    this.shapefileflag = false;
    if(this.basicValidation(type)){
      let postOpt = {};
      postOpt['zipFile'] = this.shapefileupload[type]
      postOpt['stateName'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityName']
      this.activespineer = true;
      if(type === 'aquiferfile'){
          this.submitdataService.shapefileupload(postOpt).subscribe(data =>{
            // let data = {
            //   "data": null,
            //   "et_count": "1",
            //   "h_list": [
            //       "DISTRICT",
            //       "STATE"
            //   ],
            //   "key": "8c36d982-c1c5-4bb8-b6d3-5e4e93582918",
            //   "mssg": "SHAPEFILE UPLOADED AND VALIDATED SUCCESSFULLY",
            //   "state_name_shp": "KERALA",
            //   "success": 1,
            //   "table_name": "cwmi_shp_kerala_2020_06_30"
            // }
            this.shapefileresponse = data;
            console.log("success")
            if(data.success == 1){
              if(this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityName'] == data['state_name_shp']){
                this.toastr.success("Shape File Uploaded Successfully")
                data['h_list'].reverse();
                this.shapefileupload['hierarchy'] = data['h_list'].join(' -> ')
                this.shapefileupload['unit'] = data['h_list'][1]
                this.shapefileflag = true;
              } else {
                this.toastr.error("Please upload valid shape file of logged in state");
              }
            } else {
              this.toastr.error("Please upload valid shape file of logged in state:: MSG : "+data['mssg']);
            }

            this.activespineer = false;
          },function(err){
            console.log("error",err)
            this.toastr.error("Please try again")
            this.activespineer = false;
          })
      }
      console.log("shapefileupload",this.shapefileupload)
    }
  }
  submitdata(){
    if(this.basicValidation(null)){
      let postdata = {
        "pojo" :{
          "1" : {
            "key" : this.shapefileresponse['key'],
            "assUnit" : this.shapefileupload['unit'],
            "stateId" : this.shapefileupload['state'],
            "stateName" : this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityName'],
            "type" : "primary",
            "hList" : this.shapefileresponse['h_list'],
            "assYear" : this.shapefileupload['assesmentyear']
          }
        }
      }
      this.submitdataService.automationaggregate(postdata).subscribe(data=>{
        //   let  data = {
        //     "assUnit": [
        //         "DISTRICT"
        //     ],
        //     "hierarchyType": [
        //         "primary"
        //     ],
        //     "mssg": "AGGREGATION INITIATED",
        //     "stateName": "KERALA",
        //     "success": 1
        // }
        if(data.success == 1){
          this.toastr.success(data['mssg'])
          this.initializeOnStateLoad()
        } else {
          this.toastr.error("Error while submitting data")
        }
      })
    }
  }

  public basicValidation(type){
    console.log(document.getElementById('fileupload')['value'])
      if(type){
        this.validation[0] = this.utils.checkfield(this.shapefileupload[type])
        return this.validation[0];
      } else {
        this.validation[0] = this.utils.checkfield(this.shapefileupload['aquiferfile'])
        this.validation[1] = this.utils.checkfield(this.shapefileupload['assesmentyear'])
        this.validation[2] = this.utils.checkfield(this.shapefileupload['unit'])
        this.validation[3] = this.utils.checkfield(this.shapefileupload['hierarchy'])
        return this.validation[0] && this.validation[1] && this.validation[2] && this.validation[3]
      }
 
  }
 
  public fileuploadchange(event,type){
  if(event.target.files.length > 0) 
    {
      if(this.checkTypeOfFile(event.target.files[0].name) && type === 'aquiferfile'){
        this.shapefileupload['aquiferfile'] = event.target.files[0];
        this.setfilevalidate(type,true);
      }else if(this.checkTypeOfFile(event.target.files[0].name) && type === 'notifyareafile'){
        this.shapefileupload['notifyareafile'] = event.target.files[0];
        this.setfilevalidate(type,true);
      }else{
        this.setfilevalidate(type,false);
      }
    }else{
      this.setfilevalidate(type,false);
    }
  }
  private setfilevalidate(type,flag){
      this.validation[0] = flag 
  }
  public checkTypeOfFile(filename){
    filename = filename.split('.');
    if(filename[filename.length-1] === 'zip' || filename[filename.length-1] === 'ZIP'){
      return true;
    }else{
      return false;
    }
  }
}
